import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Box, Link } from '@mui/material';
import { AuthorTooltipContent } from './AuthorTooltipContent';
import type { AuthorLinkTooltipVariantProps } from './types';
type AuthorLinkTooltipProps = Omit<AuthorLinkTooltipVariantProps, 'variant'>;
export function AuthorLinkTooltip(t0) {
  const $ = _c(18);
  const {
    name,
    link,
    bio,
    avatarMiniatureURL,
    socialMediaLinks,
    userPage,
    trigger,
    children,
    Renderer
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== link || $[2] !== name) {
    t2 = <Box><Link variant="textSmall" href={link} underline="hover">{name}</Link></Box>;
    $[1] = link;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = trigger ?? children;
  let t4;
  if ($[4] !== Renderer || $[5] !== avatarMiniatureURL || $[6] !== bio || $[7] !== link || $[8] !== name || $[9] !== socialMediaLinks || $[10] !== userPage) {
    t4 = <AuthorTooltipContent name={name} link={link} avatarMiniatureURL={avatarMiniatureURL} socialMediaLinks={socialMediaLinks} userPage={userPage} bio={bio} Renderer={Renderer} />;
    $[4] = Renderer;
    $[5] = avatarMiniatureURL;
    $[6] = bio;
    $[7] = link;
    $[8] = name;
    $[9] = socialMediaLinks;
    $[10] = userPage;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <InfoTooltip ariaLabel="Toggle Author Details" trigger={t3} maxWidth="294px" rounded={true}>{t4}</InfoTooltip>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t5) {
    t6 = <Box data-testid="author-tooltip" sx={t1}>{t2}{t5}</Box>;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}